var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_c('MetaNav',{attrs:{"open":_vm.mainNavOpen,"onlyLogoutLink":!!_vm.$route.meta.hideMainNav},on:{"toggleMobileNavigation":_vm.toggleNav}}),(!_vm.$route.meta.hideMainNav)?[_c('MainNav',{attrs:{"isOpen":_vm.mainNavOpen,"navItems":[
        _vm.nav(_vm.$t('mainNav.item.overview'), _vm.routes.ROUTE_DASHBOARD, 'home-line'),
        _vm.nav(_vm.$t('mainNav.item.taskScheduler'), _vm.routes.ROUTE_TASK_SCHEDULER, 'survey-line'),
        {
          ..._vm.nav(
            _vm.$t('mainNav.item.service'),
            _vm.routes.ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
            'service-line'
          ),

          subNavItem: [
            _vm.nav(
              _vm.$t('mainNav.item.service.careLevel'),
              _vm.routes.ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
              undefined,
              false
            ),
            _vm.nav(
              _vm.$t('mainNav.item.service.careService'),
              _vm.routes.ROUTE_SERVICE_PFLEGELEISTUNGSFINDER
            ),
            /*nav(
              $t('mainNav.item.service.burdonScaleForFamilyCaregivers'),
              routes.ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS
            ),
            {
            ...nav('Weitere Hilfen', '#'),
            subNavItem: [
              nav('Weitere Hilfen Sub 1', '#'),
              nav('Weitere Hilfen Sub 2', '#', undefined, true),
              nav('Weitere Hilfen Sub 3', '#'),
            ],
          },*/
          ],
        },
        {
          ..._vm.nav(_vm.$t('mainNav.item.analyses'), _vm.routes.ROUTE_ANALYSE_CARE_LEVEL, 'pie-chart-line'),

          subNavItem: [
            _vm.nav(_vm.$t('mainNav.item.analyses.careLevel'), _vm.routes.ROUTE_ANALYSE_CARE_LEVEL),
            _vm.nav(_vm.$t('mainNav.item.analyses.careService'), _vm.routes.ROUTE_ANALYSE_CARE_SERVICE),
            /*nav(
              $t('mainNav.item.analyses.burdonScaleForFamilyCaregivers'),
              routes.ROUTE_ANALYSE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS
            ),*/
          ],
        },
        _vm.nav(_vm.$t('mainNav.item.applications'), _vm.routes.ROUTE_APPLICATIONS, 'file-list-2-line'),
        _vm.nav(_vm.$t('mainNav.item.careProfiles'), _vm.routes.ROUTE_CARE_PROFILES, 'folder-user-line'),
      ]},on:{"toggleNav":_vm.toggleNav}}),_c('div',{class:`${_vm.el}__content`},[_c('Container',[_vm._t("default"),_c('Footer')],2)],1)]:_c('div',[_c('div',{class:`${_vm.el}__content ${_vm.el}__content--full`},[_vm._t("default"),_c('Footer')],2)]),_c('Modal',{attrs:{"size":"s","headline":_vm.$t('careLevelModal.headline'),"open":_vm.showCareLevelModal,"overflow":""},on:{"close":_vm.closeModal}},[(_vm.showCareLevelModal)?_c('CareLevelForm',{attrs:{"isSendable":"","defaultCareLevel":_vm.careLevelSituation === 0 ? _vm.careLevel : null,"defaultCareLevelDate":_vm.careLevelSituation === 0 ? _vm.careLevelDate : null,"careLevelIsResettable":""},on:{"trackingLinkClicked":_vm.trackClick}}):_vm._e()],1),(_vm.unregisteredUuid !== null)?_c('CareLevelAnalysisModal'):_vm._e(),_c('FeedbackLayer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }